import { Box, Button, Icon, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { EvidenceDetailProps } from "./type"
import { EvidenceCard } from "../../../../../reportFolio/pages/dashboard/components"
import { icons } from "../../../../../../utils/icons"
import { Fragment, useEffect, useState } from "react"
import { ModelThree } from "../../../../../reportFolio/pages/dashboard/components/details"
import { useTranslation } from "react-i18next"
import { EvidencesTypeValueEnum } from "../../../../../../utils/enums/evidences"
import { NoResponse } from "../../../../../../components/errors/noResponse"
import { useAccordions, useEvidenceDownload } from "../../../../../calendar/pages/detail/hooks"
import { TypeEvidence } from "./enums/typeEvidence"
import { SnackSimple } from "../../../../../../components"

function EvidenceDetail({
    existEvidences,
    evidences,
}: EvidenceDetailProps) {
    const styles = useStyles()
    const { t } = useTranslation()
    const {
        expandedAccordions,
        expandAll,
        toggleAccordions,
        toggleAccordion
    } = useAccordions(evidences);


    return (
        <>
            {!!existEvidences ? (
                <>

                    <Box sx={styles.buttonState}>
                        <Button variant='text_primary' onClick={toggleAccordions}>{expandAll ? t('schedule.buttons.collapseAll') : t('schedule.buttons.expandAll')}</Button>
                    </Box>

                    <Box sx={styles.bodyContainer} >
                        {!!evidences?.image?.length && <EvidenceCard newStyle evidences={evidences?.image} type={EvidencesTypeValueEnum.IMAGE} expanded={!!expandedAccordions.image} onToggle={() => toggleAccordion(TypeEvidence.IMAGE)} />}

                        {!!evidences?.sign?.length && <EvidenceCard newStyle evidences={evidences?.sign} type={EvidencesTypeValueEnum.SIGN} expanded={!!expandedAccordions.sign} onToggle={() => toggleAccordion(TypeEvidence.SIGN)} />}

                        {!!evidences?.video?.length && <EvidenceCard newStyle evidences={evidences?.video} type={EvidencesTypeValueEnum.VIDEO} expanded={!!expandedAccordions.video} onToggle={() => toggleAccordion(TypeEvidence.VIDEO)} />}

                        {!!evidences?.comment?.length && <EvidenceCard newStyle evidences={evidences?.comment} type={EvidencesTypeValueEnum.COMMENT} expanded={!!expandedAccordions.comment} onToggle={() => toggleAccordion(TypeEvidence.COMMENT)} />}

                        {!!evidences?.documents?.length && <EvidenceCard newStyle evidences={evidences?.documents} type={EvidencesTypeValueEnum.DOCUMENT} expanded={!!expandedAccordions.documents} onToggle={() => toggleAccordion(TypeEvidence.DOCUMENTS)} />}
                    </Box>
                </>
            ) : (
                <NoResponse label={t('reportFolio.detail.general.noInformation')} />
            )}
        </ >
    )
}

export default EvidenceDetail